import TemplateLogin from './TemplateLogin'

export default TemplateLogin
